<template>
  <Teleport v-if="isLoaded" to="#header_text">
    <div class="flex flex-row h-20 mt-4">
      <div
        v-if="backTarget || backTargetFunc || backTargetBrowser"
        class="flex items-center h-full bg-bkk-50 rounded-lg mr-4 cursor-pointer"
        tabindex="0"
        @click="goBack()"
        @keydown.enter.prevent="goBack()"
      >
        <ChevronIcon />
      </div>
      <div
        v-if="single"
        class="flex flex-col justify-center items-center text-display1 max-w-96 lg:max-w-2xl h-24 overflow-hidden self-center pb-2.5"
      >
        <h1 class="italic line-clamp-2 pb-2"><slot name="bottom"></slot></h1>
      </div>
      <div v-else>
        <h1 class="flex text-display1 justify-between flex-col pb-2.5">
          <slot name="top"></slot>
          <span class="italic"><slot name="bottom"></slot></span>
        </h1>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import ChevronIcon from "../../icon/ChevronIcon.vue";
import { useRouter } from "vue-router";

const isLoaded = ref(false);
const router = useRouter();

onMounted(() => {
  isLoaded.value = true;
});

const props = defineProps({
  backTarget: {
    type: String,
  },
  backTargetFunc: {
    type: Function,
  },
  backTargetBrowser: {
    type: Boolean,
    default: false,
  },
  single: {
    type: Boolean,
    default: false,
  },
});

function goBack() {
  if (props.backTargetBrowser) {
    window.history.back();
  } else if (props.backTarget) {
    router.push({
      name: props.backTarget,
    });
  } else if (props.backTargetFunc) {
    props.backTargetFunc();
  } else {
    router.back();
  }
}
</script>
